import React, { createContext, useContext, useEffect, useState } from "react";
import { getMe, login as loginApi, logoutApi } from "../api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null=checking, false=guest, obj=auth
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("cwf_token");
    if (!token) {
      setUser(false);
      setReady(true);
      return;
    }
    getMe()
      .then((u) => setUser(u))
      .catch(() => {
        localStorage.removeItem("cwf_token");
        setUser(false);
      })
      .finally(() => setReady(true));
  }, []);

  const signIn = async (email, password) => {
    const data = await loginApi(email, password);
    localStorage.setItem("cwf_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const signOut = async () => {
    localStorage.removeItem("cwf_token");
    setUser(false);
    try { await logoutApi(); } catch (e) {}
  };

  return (
    <AuthContext.Provider value={{ user, ready, signIn, signOut }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
